export const DEFAULT_LANG = "en";
